class TCFManager {
  constructor(config) {
    this.grants = config.grants;
    this.accountId = config.accountId;
    this.privacyManagerId = config.privacyManagerId;
    this.propertyId = config.propertyId;
    this.baseEndpoint = config.baseEndpoint;
    this.privacyManagerModalId = config.privacyManagerModalId;
    this.privacyLink = config.privacyLink;
    this.accentColor = config.accentColor;
    this.fontFamily = config.fontFamily;
    this.initializeBannerTool();
    this.initializeTCF();
    this.eventListeners = [];
  }

  initializeBannerTool() {
    (function() {
      var t = function() {
        var t, e, o = [], n = window, r = n;
        for (; r; ) {
          try {
            if (r.frames.__tcfapiLocator) {
              t = r;
              break;
            }
          } catch (t) {}
          if (r === n.top) break;
          r = n.parent;
        }
        t || (!function t() {
          var e = n.document, o = !!n.frames.__tcfapiLocator;
          if (!o) if (e.body) {
            var r = e.createElement("iframe");
            r.style.cssText = "display:none", r.name="__tcfapiLocator", e.body.appendChild(r);
          } else setTimeout(t, 5);
          return !o;
        }(), n.__tcfapi = function() {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
          if (!n.length) return o;
          "setGdprApplies" === n[0] ? n.length > 3 && 2 === parseInt(n[1], 10) && "boolean" == typeof n[3] && (e = n[3], "function" == typeof n[2] && n[2]("set", !0)) : "ping" === n[0] ? "function" == typeof n[2] && n[2]({ gdprApplies: e, cmpLoaded: !1, cmpStatus: "stub" }) : o.push(n);
        }, n.addEventListener("message", function(t) {
          var e = "string" == typeof t.data, o = {};
          if (e) try {
            o = JSON.parse(t.data);
          } catch (t) {} else o = t.data;
          var n = "object" === typeof o ? o.__tcfapiCall : null;
          n && window.__tcfapi(n.command, n.version, function(o, r) {
            var a = { __tcfapiReturn: { returnValue: o, success: r, callId: n.callId } };
            t && t.source && t.source.postMessage && t.source.postMessage(e ? JSON.stringify(a) : a, "*");
          }, n.parameter);
        }, !1));
      };
      "undefined" != typeof module ? module.exports = t : t();
    })();

    window._sp_queue = [];
    window._sp_ = {
      config: {
        accountId: this.accountId,
        privacyManagerId: this.privacyManagerId,
        propertyId: this.propertyId,
        baseEndpoint: this.baseEndpoint,
        gdpr: {}
      }
    };

    // Laden des externen Skripts
    const script = document.createElement('script');
    script.src = `${this.baseEndpoint}/unified/wrapperMessagingWithoutDetection.js`;
    script.async = true;
    document.head.appendChild(script);
  }

  initializeTCF() {
    window.__tcfapi('addEventListener', 2, (tcData, success) => {
      if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {      
        this.handleTCFEvent();
      }
    });
  }

  checkConsentStatus(type) {
    window.__tcfapi('getCustomVendorConsents', 2, (vendorConsents, success) => {
      if (success) {
        const { vendors } = this.grants[type];
        const granted = vendors.every(vendorId => vendorConsents.grants[vendorId]?.vendorGrant);
        if (granted) {
          this.triggerEvent('consentGiven', type);
        } else {
          this.triggerEvent('consentRequired', type);
        }
      } else {
        this.triggerEvent('consentRequired', type);
      }
    });
  }

  handleTCFEvent() {
    Object.keys(this.grants).forEach(type => {
      this.checkConsentStatus(type);
    });
  }

  addEventListener(callback) {
    this.eventListeners.push(callback);
  }

  triggerEvent(eventType, data) {
    this.eventListeners.forEach(callback => callback(eventType, data));
  }

  getVendorIds(type) {
    return this.grants[type]?.vendors || [];
  }

  getPurposeIds(type) {
    return this.grants[type]?.purposes || [];
  }

  postCustomConsent(type) {
    const vendorIds = this.getVendorIds(type);
    const purposeIds = this.getPurposeIds(type);

    window.__tcfapi('postCustomConsent', 2, () => {
      this.triggerEvent('consentGiven', type);
    }, vendorIds, purposeIds, []);
  }

  loadPrivacyManagerModal() {
    window._sp_.gdpr.loadPrivacyManagerModal(this.privacyManagerModalId);
  }
}

// Exportieren der TCFManager-Klasse, aber nicht initialisieren
window.TCFManager = TCFManager;
